<template>
  <div class="welcome">
    <section class="headtop">
      <div class="container">
        <h1>Welcome to MCSim</h1>
        <p>
          Midlands Connect is engaging on work it is doing to develop a future transport strategy for the Midlands, and would like to hear your views.
          <br><br>
          MCSim is a simulation in which you can experiment with transport policy and investment and see if you can improve conditions in the MCSim world.
          <br><br>
          MCSim simulates a large region, with many of the features of the Midlands. It is a mix of urban and rural locations, with roads, rail, buses, walking and cycling all used for travel.
          <br><br>
          The simulation runs for 10 years, to 2030. You can let it run, watch how conditions change, and make changes to transport provision to see if you can make things better – for jobs, housing provision and / or carbon.  You will find that the model will respond, and you will be able to save your results and, if you like, try again to see if you can do better.
          <br><br>
          Midlands Connect is genuinely interested in your preferences and choices, and you will see, when you have finished, that you will be invited to send your choices, anonymously, to Midlands Connect.
          <br><br>
          Please take part and help us shape the future of the regional transport network. Any questions please do not hesitate to contact Midlands Connect at: <a href="mailto:MCStrategy@midlandsconnect.uk">MCStrategy@midlandsconnect.uk</a>
        </p>
        <div class="clearfix" />
      </div>
    </section>

    <div class="bottom-widget">
      <div class="container">
        <div class="col-xs-12">
          The results of MCSim are not to be treated as forecasts; you will find that a range of results can be obtained, depending on your choices and the decisions you make throughout the simulation. The comparison of  outputs should therefore rather be thought as a way of rehearsing different scenarios and searching for the most effective ways of enhancing the region.
        </div>
      </div>
    </div>

    <div class="bottom-widget">
      <div class="container">
        <div class="pull-right">
          <router-link
            to="/scenarios"
            class="btn btn-primary btn-lg"
          >
            Next
          </router-link>
        </div>
        <div class="clearfix" />
      </div>
    </div>
    <template v-if="savedRuns.length > 0">
      <div class="widget bottom-widget">
        <div class="container">
          <div class="row">
            <h4>Saved runs:</h4>
            <table class="table table-striped">
              <tbody>
                <template v-for="(run, index) in savedRuns">
                  <tr :key="index">
                    <td>
                      {{ run.name }}
                    </td>
                    <td class="text-right">
                      <button
                        class="btn btn-sm btn-primary"
                        @click="loadRun(index)"
                      >
                        <span>View</span>
                      </button>
                      &nbsp;
                      <button
                        class="btn btn-sm btn-primary"
                        @click="deleteRunButtonClicked(index)"
                      >
                        <span>Delete</span>
                      </button>
                    </td>
                  </tr>
                </template>
              </tbody>
            </table>
          </div>
          <div class="clearfix" />
        </div>
      </div>
    </template>
  </div>
</template>

<script>
export default {
  data() {
    return {
      sharedStorage: this.$root.$data.sharedStorage,
      savedRuns: this.$root.$data.sharedStorage.getSavedRuns(),
      mapPopupData: {},
      selectedIndexToDelete: -1
    };
  },
  created() {
    this.$root.$data.eventHub.$on(
      "show-deletesavedrun-trigger",
      this.deleteRun
    );
  },
  methods: {
    loadRun(index) {
      const savedRun = this.sharedStorage.getSavedRuns()[index];
      this.sharedStorage.loadSavedRun({ savedData: savedRun });
      this.$router.push("/results");
    },
    deleteRunButtonClicked(index) {
      this.selectedIndexToDelete = index;
      this.$root.$data.eventHub.$emit("show-deletesavedrun-modal");
    },
    deleteRun() {
      if (this.selectedIndexToDelete < 0) {
        return;
      }
      this.sharedStorage.deleteSavedRun({ index: this.selectedIndexToDelete });
      this.savedRuns = this.sharedStorage.getSavedRuns();
      this.selectedIndexToDelete = -1;
    },
    displayModal(modalName) {
      this.$root.$data.eventHub.$emit("show-" + modalName + "-modal");
    }
  }
};
</script>

<style lang="scss">
.map {
  width: 100%;
}
.welcome .headtop {
  padding-bottom: 25px;

  A {
  color: white;
  text-decoration: underline;

  &:active,
  &:hover {
    text-decoration: none;
  }
}
}
</style>
